<template>
	<div class="home-container">
		<div class="home-scroll">
			<!-- 顶部 Logo 区域 -->
			<div class="logo-box">
				<img src="/img/loginhome/logo.4228a5ba.webp" width="30%">
			</div>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<div class="top-banner-wrapper">
					<swiper v-if="topProducts.length > 0" class="top_swiper" :options="topSwiperOption">

						<swiper-slide v-for="v in topProducts" :key="v.id">
							<div class="banner-item">
								<van-image class="banner_img" fit="cover" :src="v.cover" />
							</div>
						</swiper-slide>
						<div class="swiper-pagination" slot="pagination"></div>
					</swiper>
				</div>

			</van-pull-refresh>
			<div class="intro-text">
				<span style="color:#e62978;font-size:1.1rem;"><strong>【 Serene Love클럽® 대한민국 No.1의 어른 장난감 쇼핑
						센터】</strong></span>
				<p><strong style="font-size:1.1rem">| 프라이버시 | 품질 | 안전 | 즐거움 |</strong></p>
			</div>


			<div class="top-banners">
				<img src="/img/loginhome/banner.0effebd8.jpg" class="banner-img-wide">
				<img src="/img/loginhome/categories.9d5d7f01.png" class="banner-img-full">
				<img src="/img/loginhome/banner2.5774cecb.jpg" class="banner-img-full">
			</div>

			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">

				<div class="category-wrapper">
					<div class="category-header pink-bg">
						<span class="emoji">✈️</span> 남성용 섹스 장난감
					</div>
					<div class="swiper-container-box">
						<swiper v-if="menProducts.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in menProducts" :key="'men-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<div class="tag">남성 탑 HOT</div>
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<img class="rank-badge" v-if="key < 3" :src="'/img/home/no' + (key + 1) + '.png'">
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
										<div class="old-price">₩ {{ v.old_price }}</div>
									</div>
								</div>
							</swiper-slide>
							<!-- 小圆点插槽 -->
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>

				<div class="category-wrapper">
					<div class="category-header pink-bg">
						👩‍❤️‍👩 레즈비언 섹스 제품
					</div>
					<div class="swiper-container-box">
						<swiper v-if="womenProducts.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in womenProducts" :key="'women-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<div class="tag-women">여성용 TOP {{ key + 1 }}</div>
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
										<div class="old-price">₩ {{ v.old_price }}</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>

				<div class="category-wrapper">
					<div class="category-header pink-bg">
						🍌 여성용 섹스 제품
					</div>
					<div class="swiper-container-box">
						<swiper v-if="sex3Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in sex3Products" :key="'sex3-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<div class="tag-women">여성용 TOP {{ key + 1 }}</div>
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
										<div class="old-price">₩ {{ v.old_price }}</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>
				<div class="category-wrapper">
					<div class="category-header pink-bg">
						😘 커플용 섹스 제품
					</div>
					<div class="swiper-container-box">
						<swiper v-if="sex4Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in sex4Products" :key="'sex4-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<div class="tag-women">여성용 TOP {{ key + 1 }}</div>
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
										<div class="old-price">₩ {{ v.old_price }}</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>
				<div class="category-wrapper">
					<div class="category-header pink-bg">
						👨‍❤️‍👨 게이 섹스 제품
					</div>
					<div class="swiper-container-box">
						<swiper v-if="sex5Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in sex5Products" :key="'sex5-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<div class="tag-women">여성용 TOP {{ key + 1 }}</div>
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
										<div class="old-price">₩ {{ v.old_price }}</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>
				<div class="category-wrapper">
					<div class="category-header pink-bg">
						👩‍❤️‍👩 레즈비언 섹스 제품
					</div>
					<div class="swiper-container-box">
						<swiper v-if="sex6Products.length > 0" class="movie_swiper" :options="movielistSwiperOption">
							<swiper-slide v-for="(v, key) in sex6Products" :key="'sex6-' + key">
								<div class="product-card" @click="toPlayVideo(v.id)">
									<div class="tag-women">여성용 TOP {{ key + 1 }}</div>
									<van-image class="movie_cover" fit="cover" :src="v.cover">
										<template v-slot:loading><van-loading type="circular" size="20" /></template>
									</van-image>
									<div class="info-box">
										<div class="title">{{ v.title }}</div>
										<div class="price">₩ {{ v.price }}</div>
										<div class="old-price">₩ {{ v.old_price }}</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-pagination" slot="pagination"></div>
						</swiper>
					</div>
				</div>


			</van-pull-refresh>
			<h2 style="background-color:rgb(239, 239, 239);padding:10px;border-radius:8px;margin-bottom:5px;text-align:center;"
				data-v-08c62a6f=""><a href="#/login" target="_blank" data-v-08c62a6f=""><span
						style="font-size:26px;color:rgb(230, 41, 120);" data-v-08c62a6f=""><strong
							data-v-08c62a6f="">재미있는
							칼럼</strong></span></a></h2>
			<div class="banner">
				<img src="/img/loginhome/happy1.b62f25ab.jpg"><br>
				<img src="/img/loginhome/happy2.e0c347de.jpg"><br>
				<img src="/img/loginhome/happy3.444f9053.jpg"><br>
				<img src="/img/loginhome/happy4.63fcd286.jpg"><br>
				<img src="/img/loginhome/happy5.0e688d23.jpg"><br>
				<img src="/img/loginhome/happy6.196ee02d.jpg"><br>
			</div>

			<div>
				<h2 style="background-color:rgb(239, 239, 239);padding:10px;border-radius:8px;margin-bottom:5px;text-align:center;"
					data-v-08c62a6f=""><a href="#/login" target="_blank" data-v-08c62a6f=""><span
							style="font-size:26px;color:rgb(230, 41, 120);" data-v-08c62a6f=""><strong
								data-v-08c62a6f="">브랜드
								존</strong></span></a></h2>
			</div>
			<div class="wo">
				<div style="float: left;width: 50%;"><img src="/img/loginhome/brand1.d63f4973.webp"></div>
				<div style="float:right;width: 50%;"><img src="/img/loginhome/brand2.6ab5fd63.webp"></div>
			</div>
			<div class="wo">
				<div style="float: left;width: 50%;"><img src="/img/loginhome/brand3.8995492b.webp"></div>
				<div style="float:right;width: 50%;"><img src="/img/loginhome/brand4.9530cb0b.webp"></div>
			</div>
			<div class="wo">
				<div style="float: left;width: 50%;"><img src="/img/loginhome/brand5.c76aebdd.webp"></div>
				<div style="float:right;width: 50%;"><img src="/img/loginhome/brand6.70dd7c45.webp"></div>
			</div>
			<div class="wo">
				<div style="float: left;width: 50%;"><img src="/img/loginhome/brand7.90f73ace.webp"></div>
				<div style="float:right;width: 50%;"><img src="/img/loginhome/brand8.0464c3f9.webp"></div>
			</div>


			<div style="width: 100%; background-color: antiquewhite;">
				<div class="wo">
					<div style="float: left;width: 50%;"><img src="/img/loginhome/footer1.35de1a0a.png"></div>
					<div style="float:right;width: 50%;"><img src="/img/loginhome/footer2.7b17382c.png"></div>
				</div>
				<div class="wo">
					<div style="float: left;width: 50%;"><img src="/img/loginhome/footer3.72eb04d3.png"></div>
					<div style="float:right;width: 50%;"><img src="/img/loginhome/footer4.23c66537.png"></div>
				</div>
				<div class="end">

					<span>｜쇼핑 정보｜</span><br>
					Serene Love클럽에 대하여<br>
					이용약관<br>
					개인정보처리방침<br>
					판매 대리
					<br>신청 매장 정보
					<br><span>｜쇼핑 가이드｜</span>
					<br>배송 및 결제 반품 및 교환 안내
					<br>제조물 책임 보험<br>사기 방지 안내<br>자주 묻는 질문
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isLoading: false,
			// ==========================================	
			// 这里的数组就是你要手动修改的产品数据
			// ==========================================
			menProducts: [
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/p (1).webp' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/p (2).webp' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/p (3).webp' },
				{ id: 4, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/p (4).webp' },
				{ id: 5, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/p (5).webp' },
				{ id: 6, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/p (6).webp' },
				{ id: 7, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/p (7).webp' },
				{ id: 8, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/p (8).webp' },
				{ id: 9, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/p (9).webp' },
				{ id: 10, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/p (10).webp' },
				{ id: 11, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/p (11).webp' },
				{ id: 12, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/p (12).webp' },
				{ id: 13, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/p (13).webp' },
				{ id: 14, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/p (14).webp' },
				{ id: 15, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/p (15).webp' },
				{ id: 16, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/p (16).webp' }
			],
			topProducts: [
				{ id: 1, cover: '/img/loginhome/swipe5.0e3b3c92.jpg' },
				{ id: 2, cover: '/img/loginhome/swipe6.c823b806.jpg' },
				{ id: 3, cover: '/img/loginhome/swipe4.f961370f.jpg' },
				{ id: 4, cover: '/img/loginhome/swipe2.d16bbfd4.jpg' },
				{ id: 5, cover: '/img/loginhome/swipe1.b9128a78.jpg' }
			],
			womenProducts: [
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/n (1).webp' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/n (2).webp' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/n (3).webp' },
				{ id: 4, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/n (4).webp' },
				{ id: 5, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/n (5).webp' },
				{ id: 6, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/n (6).webp' },
				{ id: 7, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/n (7).webp' },
				{ id: 8, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/n (8).webp' },
				{ id: 9, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/n (9).webp' },
				{ id: 10, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/n (10).webp' },
				{ id: 11, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/n (11).webp' }
			],
			sex3Products: [
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/v (1).webp' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/v (2).webp' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/v (3).webp' },
				{ id: 4, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/v (4).webp' },
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/v (5).webp' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/v (6).webp' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/v (7).webp' }
			],
			sex4Products: [
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/b (1).webp' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/b (2).webp' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/b (3).webp' },
				{ id: 4, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/b (4).webp' },
				{ id: 5, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/b (5).webp' },
				{ id: 6, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/b (6).webp' },
				{ id: 7, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/b (7).webp' },
				{ id: 8, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/b (8).webp' }
			],
			sex5Products: [
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/g (1).webp' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/g (2).webp' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/g (3).webp' },
				{ id: 4, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/g (4).webp' },
				{ id: 5, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/g (5).webp' }
			],
			sex6Products: [
				{ id: 1, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/l (1).webp' },
				{ id: 2, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/l (2).webp' },
				{ id: 3, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/l (3).webp' },
				{ id: 4, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/l (4).webp' },
				{ id: 5, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/l (5).webp' },
				{ id: 6, title: 'Special Item', price: '12,500', old_price: '18,000', cover: '/img/loginhome/l (6).webp' },
				{ id: 7, title: 'Extra Product', price: '8,800', old_price: '12,000', cover: '/img/loginhome/l (7).webp' }
			],
			// Swiper 轮播图配置
			topSwiperOption: {
				slidesPerView: 1,
				loop: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				// --- 必须添加以下三个参数 ---
				observer: true,                // 修改 swiper 自己或子元素时，自动初始化 swiper
				observeParents: true,          // 修改 swiper 的父元素时，自动初始化 swiper
				loopAdditionalSlides: 3,       // 额外克隆几个滑块，防止循环到最后出现空白
			},
			movielistSwiperOption: {
				slidesPerView: 2.2,
				spaceBetween: 12,
				loop: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				// 关键：确保这里的 el 对应 HTML 里的 class
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				observer: true,
				observeParents: true,
			},
		};
	},
	methods: {
		onRefresh() {
			// 模拟刷新逻辑
			setTimeout(() => {
				this.isLoading = false;
				this.$toast("새로고침 성공");
			}, 1000);
		},
		toPlayVideo(id) {
			if (!localStorage.getItem('token')) {
				this.$router.push({ path: '/Login' });
			} else {
				this.$router.push({ path: '/home?id=' + id });
			}
		}
	}
}
</script>

<style lang='less' scoped>
.home-container {
	background-color: #f8f8f8;
	min-height: 100vh;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
}

.logo-box {
	padding: 20px;
	text-align: center;
	background: #fff;
}

.intro-text {
	padding: 10px;
	text-align: center;
	font-size: 24px;
	color: #666;
	background: #fff;

	p {
		margin: 5px 0;
	}
}

.banner-img-wide {
	width: 90%;
	margin: 10px auto;
	display: block;
	border-radius: 10px;
}

.banner-img-full {
	width: 100%;
	display: block;
}

.category-wrapper {
	margin-bottom: 20px;
	background: #fff;
	padding-bottom: 20px;
}

/* 粉色标题栏样式 */
.category-header {
	height: 90px;
	margin: 20px;
	border-radius: 15px;
	display: flex;
	align-items: center;
	padding: 0 30px;
	color: #fff;
	font-size: 32px;
	font-weight: bold;
	background-color: #d64a79;

	.emoji {
		margin-right: 15px;
		font-size: 40px;
	}
}

.swiper-container-box {
	padding: 0 20px;
	overflow: visible;
	/* 关键：允许小圆点显示 */
}

.movie_swiper {
	padding-bottom: 70px !important;
	/* 给底部圆点留出空间 */
	overflow: visible !important;
}

/* 卡片样式 */
.product-card {
	background: #fff;
	border: 1px solid #eee;
	border-radius: 15px;
	position: relative;
	overflow: hidden;
	padding-bottom: 15px;
	height: 100%;

	.tag,
	.tag-women {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
		color: #fff;
		font-size: 18px;
		padding: 5px 15px;
		border-radius: 0 0 15px 0;
		background: #d64a79;
	}

	.tag-women {
		background: #e07094;
	}

	.movie_cover {
		width: 100%;
		height: 280px;
	}

	.rank-badge {
		position: absolute;
		top: 10px;
		right: 10px;
		width: 60px;
		z-index: 10;
	}

	.info-box {
		padding: 15px 10px 5px;

		.title {
			font-size: 26px;
			color: #333;
			height: 34px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.price {
			font-size: 28px;
			color: #d64a79;
			font-weight: bold;
			margin-top: 8px;
		}

		.old-price {
			font-size: 22px;
			color: #999;
			text-decoration: line-through;
			margin-top: 5px;
		}
	}
}

/* 分页器小圆点样式 */
.movie_swiper {
	/* 必须给底部留出足够的空间放圆点，否则会被 overflow:hidden 遮住 */
	padding-bottom: 60px !important;
	position: relative;
	overflow: visible !important;
	/* 允许圆点溢出显示 */
}

.banner img {
	width: 100%;
}

.wo {
	text-align: center;
	margin: 0 auto;
	width: 100%;
	height: 340px;
	margin: 10px;

}

.wo img {
	width: 80%;
	padding: 10px;

}

.end {
	text-align: center;
	padding-bottom: 200px;
	padding-top: 20px;
	font-size: 25px;
}

.end span {
	font-size: 40px;
	font-weight: 900;

}

/* 确保圆点本身有颜色（有时候是透明的看不见） */
::v-deep .swiper-pagination {
	bottom: 10px !important;
	/* 调整圆点距离底部的距离 */
	left: 0;
	width: 100%;
	text-align: center;
}

::v-deep .swiper-pagination-bullet {
	width: 12px !important;
	height: 12px !important;
	background: #ccc !important;
	/* 未激活的颜色：灰色 */
	opacity: 1 !important;
	margin: 0 5px !important;
}

::v-deep .swiper-pagination-bullet-active {
	background: #d64a79 !important;
	/* 激活后的颜色：粉色 */
}
</style>